import * as actionTypes from './actionTypes';

export const REQUESTS_FOR_GLOBAL_INDICATOR = [
  actionTypes.GET_DATA_SOURCES_REQUEST,
  actionTypes.GET_DATA_SOURCE_REQUEST,
  actionTypes.GET_SINKS_REQUEST,
  actionTypes.GET_SINK_REQUEST,
  actionTypes.GET_DATA_SETS_REQUEST,
  actionTypes.GET_DATA_SETS_SUMMARY_REQUEST,
  actionTypes.GET_DATA_SET_REQUEST,
  actionTypes.GET_DATA_SET_FOR_ROUTING_REQUEST,
  actionTypes.GET_AVAILABLE_DATASETS_REQUEST,
  actionTypes.GET_AVAILABLE_DATASETS_SUMMARY_REQUEST,
  actionTypes.GET_AVAILABLE_DATASET_REQUEST,
  actionTypes.GET_AVAILABLE_DATASET_SUMMARY_REQUEST,
  actionTypes.GET_PUBLIC_DATASETS_REQUEST,
  actionTypes.GET_PUBLIC_DATASETS_SUMMARY_REQUEST,
  actionTypes.GET_PUBLIC_DATASET_REQUEST,
  actionTypes.GET_PUBLIC_DATASET_SUMMARY_REQUEST,
  actionTypes.GET_ALL_DATA_MAPS_REQUEST,
  actionTypes.CREATE_DATA_MAP_REQUEST,
  actionTypes.UPDATE_DATA_MAP_REQUEST,
  actionTypes.GET_USER_ACCOUNT_SUMMARY_REQUEST,
  actionTypes.GET_PIPELINES_REQUEST,
  actionTypes.GET_DASHBOARD_METRICS_REQUEST,
  actionTypes.GET_ALL_CREDENTIALS_REQUEST,
  actionTypes.GET_CREDENTIAL_REQUEST,
  actionTypes.ADD_CREDENTIAL_REQUEST,
  actionTypes.PROBE_CREDENTIAL_REQUEST,
  actionTypes.UPDATE_CREDENTIAL_REQUEST,
  actionTypes.IMPERSONATION_REQUEST,
  actionTypes.GET_USERS_REQUEST,
  actionTypes.GET_SCHEMA_SPECS_REQUEST,
  actionTypes.DELETE_SCHEMA_SPEC_REQUEST,
];

export const IGNORED_ACTION_TYPES_IN_ERROR_DISPLAY = [
  actionTypes.GET_DATA_CHARACTERISTICS_FAILURE,

  actionTypes.GET_USER_BILLABLE_EVENTS_TOTAL_FAILURE,
  actionTypes.GET_USER_ACCOUNT_SUMMARY_FAILURE,

  actionTypes.GET_ORG_BILLABLE_EVENTS_TOTAL_FAILURE,

  actionTypes.GET_USER_SOURCE_METRICS_N_DAYS_FAILURE,
  actionTypes.GET_USER_SINK_METRICS_N_DAYS_FAILURE,

  actionTypes.GET_ALL_NOTIFICATIONS_FAILURE,
  actionTypes.GET_ALL_NOTIFICATIONS_ALERT_FAILURE,
  actionTypes.GET_UNREAD_COUNTER_NOTIFICATIONS_FAILURE,

  actionTypes.GET_DASHBOARD_METRICS_FAILURE,

  actionTypes.GET_TAGS_FAILURE,

  actionTypes.GET_FLOW_METRICS_FAILURE,
  actionTypes.GET_RESOURCE_METRICS_AGGREGATE_FAILURE,
  actionTypes.GET_RESOURCE_METRICS_BY_DAYS_FAILURE,
  actionTypes.GET_FLOW_RUN_LOGS_FAILURE,
  actionTypes.GET_FLOW_RUN_LOGS_METADATA_FAILURE,
  actionTypes.GET_FLOW_RUN_LOGS_WITH_FACETS_FAILURE_V2,
  actionTypes.GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_FAILURE_V2,

  actionTypes.GET_PIPELINES_FAILURE,
  actionTypes.GET_PROJECTS_FAILURE,
  actionTypes.GET_DATA_SOURCES_FAILURE,
  actionTypes.GET_DATA_SETS_FAILURE,
  actionTypes.GET_SINKS_FAILURE,
  actionTypes.GET_DATA_MAPS_FAILURE,
  actionTypes.GET_CREDENTIALS_FAILURE,
  actionTypes.PROBE_CREDENTIAL_SILENT_FAILURE,
  actionTypes.GET_CREDENTIAL_SILENT_FAILURE,
  actionTypes.GET_CODE_CONTAINER_LISTING_FAILURE,
  actionTypes.GET_SCHEMA_SPEC_LISTING_FAILURE,
  actionTypes.GET_ALL_API_KEYS_FAILURE,

  actionTypes.SEARCH_PIPELINES_FAILURE,
  actionTypes.SEARCH_PROJECTS_FAILURE,
  actionTypes.SEARCH_DATA_SOURCES_FAILURE,
  actionTypes.SEARCH_DATA_SETS_FAILURE,
  actionTypes.SEARCH_SINK_FAILURE,
  actionTypes.SEARCH_DATA_MAPS_FAILURE,
  actionTypes.SEARCH_CREDENTIALS_FAILURE,
  actionTypes.SEARCH_CODE_CONTAINERS_FAILURE,
  actionTypes.SEARCH_SCHEMA_SPECS_FAILURE,
  actionTypes.SEARCH_API_KEYS_FAILURE,
];

export const REQUESTS_FOR_LOGIN_INDICATOR = [
  actionTypes.NEX_GTOKEN_AUTH_REQUEST,
  actionTypes.NEX_USERNAME_AUTH_REQUEST,
  actionTypes.GAPI_LOGOUT_REQUEST,
  actionTypes.NEX_SSO_AUTH_LOGIN_REQUEST,
];

export const REQUESTS_FOR_SAMPLES_LOADING = [
  actionTypes.GET_DATA_SAMPLES_REQUEST,
  actionTypes.GET_TRANSFORMED_SAMPLES_REQUEST,
];

export const REQUESTS_FOR_DATA_SETS_PAGE = [
  actionTypes.GET_DATA_SETS_REQUEST,
  actionTypes.GET_AVAILABLE_DATASETS_REQUEST,
];

export const PAGING_INFO = 'PAGING_INFO';

export const PROBE_LOCATION = 'PROBE';

export const NM_TEMPLATE = 'NM_TEMPLATE';
